import { StringHash } from '@app/shared/utils/utils-types';
import { Observable } from 'rxjs';

export class BaseSettingsGroup<TStore, TSaveInput> {
  readonly value: StringHash<any> = {};
  keys: string[];

  constructor(
    protected mainStore: TStore,
    protected defaultStore: TStore,
    protected saveData: (data: TSaveInput) => Observable<boolean>,
  ) {}
}

export function createSettingsDecorator<T extends BaseSettingsGroup<any, any>>(constructor: any) {
  return function (target: BaseSettingsGroup<any, any>, key: string) {
    target.keys = target.keys || [];
    target.keys.push(key);

    Object.defineProperty(target, key, {
      get() {
        const _this = <T>this;

        if (!_this.value[key]) {
          _this.value[key] = constructor.call(_this);
        }
        return _this.value[key];
      },
    });
  };
}
